import { useState } from 'react'
import { Button } from '@/components/ui/button'
import { ConfirmDialog } from '@/components/ui/ConfirmDialog'
import { HESTIA_OPTIONS } from '@/lib/statOptions'

interface ExchangeStep3Props {
    formData: any
    onSubmit: (data: any) => void
    onBack: () => void
    onNavigateHome: () => void
    showConfirm: boolean
    onConfirmNavigateHome: () => void
    onCancelConfirm: () => void
}

export const ExchangeStep3 = ({
    formData,
    onSubmit,
    onBack,
    onNavigateHome,
    showConfirm,
    onConfirmNavigateHome,
    onCancelConfirm
}: ExchangeStep3Props) => {
    const [hestia, setHestia] = useState({
        voisinage: formData.hestia?.voisinage || "3: Bonne entente avec le voisinage",
        hygiene: formData.hestia?.hygiene || "3: Logement impeccable et/ou aides familiales régulières et fonctionnelles",
        bailleur: formData.hestia?.bailleur || "3: Garantie du paiement du loyer et de la signature des baux"
    })

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault()
        onSubmit(hestia)
    }

    const { voisinage, hygiene, bailleur } = HESTIA_OPTIONS

    return (
        <div className="min-h-screen bg-gray-50 py-8">
            <div className="max-w-4xl mx-auto px-4">
                <h1 className="text-3xl font-bold text-gray-900 mb-8">Score HESTIA - Risque de perte de logement</h1>

                <form onSubmit={handleSubmit} className="bg-white rounded-lg shadow p-8">
                    <div className="space-y-8">
                        <div>
                            <h3 className="text-lg font-semibold text-gray-900 mb-4">Voisinage</h3>
                            <div className="space-y-2">
                                {voisinage.map(option => (
                                    <label key={option} className="flex items-start">
                                        <input
                                            type="radio"
                                            name="voisinage"
                                            value={option}
                                            checked={hestia.voisinage === option}
                                            onChange={(e) => setHestia({ ...hestia, voisinage: e.target.value })}
                                            className="mr-3 mt-1"
                                        />
                                        <span className="text-sm">{option}</span>
                                    </label>
                                ))}
                            </div>
                        </div>

                        <div>
                            <h3 className="text-lg font-semibold text-gray-900 mb-4">Hygiène et logement</h3>
                            <div className="space-y-2">
                                {hygiene.map(option => (
                                    <label key={option} className="flex items-start">
                                        <input
                                            type="radio"
                                            name="hygiene"
                                            value={option}
                                            checked={hestia.hygiene === option}
                                            onChange={(e) => setHestia({ ...hestia, hygiene: e.target.value })}
                                            className="mr-3 mt-1"
                                        />
                                        <span className="text-sm">{option}</span>
                                    </label>
                                ))}
                            </div>
                        </div>

                        <div>
                            <h3 className="text-lg font-semibold text-gray-900 mb-4">Bailleur</h3>
                            <div className="space-y-2">
                                {bailleur.map(option => (
                                    <label key={option} className="flex items-start">
                                        <input
                                            type="radio"
                                            name="bailleur"
                                            value={option}
                                            checked={hestia.bailleur === option}
                                            onChange={(e) => setHestia({ ...hestia, bailleur: e.target.value })}
                                            className="mr-3 mt-1"
                                        />
                                        <span className="text-sm">{option}</span>
                                    </label>
                                ))}
                            </div>
                        </div>
                    </div>

                    <div className="flex justify-between mt-8">
                        <Button type="button" variant="outline" onClick={onBack}>
                            Retour
                        </Button>
                        <div className="space-x-4">
                            <Button type="button" variant="outline" onClick={onNavigateHome}>
                                Accueil
                            </Button>
                            <Button type="submit">
                                Suivant
                            </Button>
                        </div>
                    </div>
                </form>
            </div>

            {showConfirm && (
                <ConfirmDialog
                    onConfirm={onConfirmNavigateHome}
                    onCancel={onCancelConfirm}
                />
            )}
        </div>
    )
} 